"use client";

import { type ReactNode, useEffect } from "react";
import { trackPublicEvent } from "@/lib/public-analytics";

export function ContentHubView({
  article = "hub",
  pagePath = "/small-business-101",
}: {
  article?: string;
  pagePath?: string;
}) {
  useEffect(() => {
    trackPublicEvent("small_business_101_view", {
      article,
      page_path: pagePath,
    });
  }, [article, pagePath]);

  return null;
}

export function FreeCheckCta({
  article = "hub",
  children,
  className,
  location,
}: {
  article?: string;
  children: ReactNode;
  className: string;
  location: string;
}) {
  return (
    <a
      href="/#free-glow-check"
      onClick={() =>
        trackPublicEvent("small_business_101_cta_click", {
          article,
          link_location: location,
        })
      }
      className={className}
    >
      {children}
    </a>
  );
}
